import { Logger } from '@/core/monitoring'

const setItem = <T = string>(key: string, value: T) => {
  try {
    let valueParsed
    if (typeof value !== 'string') {
      valueParsed = JSON.stringify(value)
    }
    valueParsed = value

    window.sessionStorage.setItem(key, valueParsed as string)
  } catch (error) {
    Logger.error('session-storage-manager', { message: 'Could not write on sessionStorage', key })
  }
}

const getItem = (key: string) => {
  try {
    const item = window.sessionStorage.getItem(key)
    if (!item) return null
    const parsedItem = JSON.parse(item)
    return parsedItem
  } catch (error) {
    Logger.error('session-storage-manager', {
      message: 'Could not get the item on sessionStorage',
      key,
    })
  }
}

const removeItem = (key: string) => {
  try {
    window.sessionStorage.removeItem(key)
  } catch (error) {
    Logger.error('session-storage-manager', {
      message: 'Could not remove the item at sessionStorage',
      key,
    })
  }
}

const sessionStorage = {
  getItem,
  setItem,
  removeItem,
}

export default sessionStorage
